import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Button, Tabs, Tab } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { creatAmenitySection, updateAmenitySection } from '../../../../../utils/PropertyAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import './Section-Create.scss';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { useDispatch, useSelector } from 'react-redux';
import { allHotelsSelector, fetchAllAmenities } from '../../../../property/propertySlice';
import './Section-Create.scss';
import { formDataValidate } from '../../../../../utils/formUtils';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import { ASSET_AMENITIES } from '../../../../../constants/AmenityConst';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const AmenitySectionCreate = (props) => {
  const { toggleDrawer, section, hotelId } = props;
  const originalHotels = useSelector(allHotelsSelector);
  const dispatch = useDispatch();
  const [rawImages, setRawImages] = useState([]);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 1,
    },
  });

  useEffect(() => {
    if (section) {
      const currFields = { ...formData };
      currFields.name.value = section?.name;
      currFields.images.value = section?.images || [];
      currFields.customAttributes.value = section?.customAttributes || [];
      setFormData(currFields);
    }
  }, [section]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onNextClick = (e) => {
    e.preventDefault();
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        const images = await getProcessedImages(
          rawImages,
          originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId,
          ASSET_AMENITIES,
          hotelId,
        );
        const payload = {
          name: formData?.name?.value,
          customAttributes: formData?.customAttributes?.value,
          images: images,
        };
        if (section) {
          payload.id = section?.id;
          await updateAmenitySection(payload, hotelId, language);
          notificationManager('success', 'Section updated successfully');
        } else {
          await creatAmenitySection(payload, hotelId, language);
          notificationManager('success', 'Section created successfully');
        }

        dispatch(fetchAllAmenities(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          section
            ? notificationManager('danger', 'Section updation failed')
            : notificationManager('danger', 'Section creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else if (validate(tabValue)) {
      setTabValue(newValue);
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData)?.filter(([key, field]) => field?.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData?.images?.value];
    images.splice(index, 1);
    setFormData({ images });
  };

  return (
    <form className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{section ? 'Edit Section' : 'Add Section'}</span>
          </div>
          <div className='col-md-5'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='amenities-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        {tabValue === 0 && (
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <div className='row px-3 w-100 mt-4'>
              <div className='col-md-6'>
                <span className='page-title-secondary'>Details</span>
              </div>
            </div>
            <div className='row px-3 w-100 d-flex mt-3'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData?.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength={100}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
            </div>
            <div>
              <KeyValuePairList
                item={formData?.customAttributes}
                onListChange={(e) => {
                  setFormData({ customAttributes: e });
                }}
              />
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <div className='col-md-12 mb-3'>
              <ImageUpload
                uploadedImages={formData?.images?.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => {
                  setLoading(status);
                }}
                enabledMediaTabs={['image']}
              />
            </div>
          </div>
        )}
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 1 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={(e) => onNextClick(e)}
                size='large'
                className='me-3'
                disabled={isTabInValid}
              >
                Next
              </Button>
            ) : (
              <Button
                variant='contained'
                type='submit'
                color='primary'
                className='me-3'
                size='large'
                disabled={loading}
                onClick={(e) => handleSubmit(e)}
              >
                {section ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default AmenitySectionCreate;
